"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertFeatureToLocation = convertFeatureToLocation;
exports.convertPositionToBbox = convertPositionToBbox;
exports.throttler = throttler;
exports.isValidDate = isValidDate;
exports.uniqBy = uniqBy;
exports.uniq = uniq;
exports.forceOrder = forceOrder;
exports.isTruthy = isTruthy;

var _helpers = require("@turf/helpers");

var _bbox3 = _interopRequireDefault(require("@turf/bbox"));

var _destination = _interopRequireDefault(require("@turf/destination"));

var _promiseThrottle = _interopRequireDefault(require("promise-throttle"));

var _rateLimits = require("./constants/rateLimits");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function convertFeatureToLocation(feature) {
  var properties = feature.properties,
      geometry = feature.geometry;
  return {
    name: properties.name,
    place: properties.id,
    coordinates: {
      latitude: geometry.coordinates[1],
      longitude: geometry.coordinates[0]
    }
  };
}

function convertPositionToBbox(coordinates, distance) {
  var latitude = coordinates.latitude,
      longitude = coordinates.longitude;
  var distanceToKilometer = distance / 1000;
  var position = (0, _helpers.point)([longitude, latitude]);
  var east = (0, _destination.default)(position, distanceToKilometer, 0);
  var north = (0, _destination.default)(position, distanceToKilometer, 90);
  var west = (0, _destination.default)(position, distanceToKilometer, 180);
  var south = (0, _destination.default)(position, distanceToKilometer, -90);
  var line = (0, _helpers.lineString)([east.geometry.coordinates, north.geometry.coordinates, west.geometry.coordinates, south.geometry.coordinates]);

  var _bbox = (0, _bbox3.default)(line),
      _bbox2 = _slicedToArray(_bbox, 4),
      minLng = _bbox2[0],
      minLat = _bbox2[1],
      maxLng = _bbox2[2],
      maxLat = _bbox2[3];

  return {
    minLng: minLng,
    minLat: minLat,
    maxLng: maxLng,
    maxLat: maxLat
  };
}

function throttler(func, args) {
  var argCount = args.length;
  var requestsPerSecond = argCount > _rateLimits.MAX_CALLS_PER_MINUTE ? Math.floor(_rateLimits.MAX_CALLS_PER_MINUTE / 60) : _rateLimits.MAX_CALLS_PER_SECOND;
  var promiseThrottle = new _promiseThrottle.default({
    requestsPerSecond: requestsPerSecond
  });
  return Promise.all(args.map(function (a) {
    return promiseThrottle.add(function () {
      return func(a);
    });
  }));
}

function isValidDate(d) {
  return Object.prototype.toString.call(d) === '[object Date]' && !Number.isNaN(d.getTime());
}

function uniqBy(arr, getKey) {
  return _toConsumableArray(arr.reduce(function (map, item) {
    var key = getKey(item);

    if (!map.has(key)) {
      map.set(key, item);
    }

    return map;
  }, new Map()).values());
}

function identity(thing) {
  return thing;
}

function uniq(arr) {
  return uniqBy(arr, identity);
}

function forceOrder(list, sequence, getKey) {
  var queue = _toConsumableArray(list);

  var result = [];
  var getKeyFunc = getKey || identity;
  sequence.forEach(function (sequenceIdentifier) {
    var item = queue.find(function (t) {
      return getKeyFunc(t) === sequenceIdentifier;
    });

    if (item) {
      result.push(item);
      queue = queue.filter(function (q) {
        return q !== item;
      });
    } else {
      result.push(undefined);
    }
  });
  return result;
}

function isTruthy(thing) {
  return Boolean(thing);
}